import { useQuery } from '@tanstack/react-query';
import { classes } from '@shared/api/services';

// Расписание преподавателя (его собственное, по teacher_slug)
export const useTeacherSchedule = (slug, params) => {
  return useQuery({
    queryKey: ['teacher-schedule', slug, params],
    queryFn: () => classes.getSchedule(slug, params),
    select: (data) => data?.data,
    enabled: !!slug && !!params?.date_from && !!params?.date_to,
  });
};
